import EventEmitter from 'events';

class AppEvents extends EventEmitter {

    preInit = () => this.emit(AppEvents.EVENTS.PRE_INIT);
    onPreInit = (handler) => this.on(AppEvents.EVENTS.PRE_INIT, handler);

    postInit = () => this.emit(AppEvents.EVENTS.POST_INIT);
    onPostInit = (handler) => this.on(AppEvents.EVENTS.POST_INIT, handler);

    modelLoaded = () => this.emit(AppEvents.EVENTS.MODEL_LOADED);
    onModelLoaded = (handler) => this.on(AppEvents.EVENTS.MODEL_LOADED, handler);

    createRecord = () => this.emit(AppEvents.EVENTS.CREATE);
    onCreateRecord = (handler) => this.on(AppEvents.EVENTS.CREATE, handler);

    saveRecord = async () => {
        const listeners = this.listeners(AppEvents.EVENTS.SAVE);
        const promises = [];

        for (const handler of listeners) {
            const result = handler();
            if (result && typeof result.then === 'function') {
                promises.push(result);
            }
        }

        try {
            await Promise.all(promises);

            this.formSubmit();
            return true;
        } catch (error) {
            console.error('Error during saveRecord:', error);
            return false;
        }
    };
    onSaveRecord = (handler) => this.on(AppEvents.EVENTS.SAVE, handler);

    formSubmit = () => this.emit(AppEvents.EVENTS.FORM_SUBMIT);
    onFormSubmit = (handler) => this.on(AppEvents.EVENTS.FORM_SUBMIT, handler);

    deleteRecord = () => this.emit(AppEvents.EVENTS.DELETE);
    onDeleteRecord = (handler) => this.on(AppEvents.EVENTS.DELETE, handler);

    refresh = () => this.emit(AppEvents.EVENTS.REFRESH);
    onRefresh = (handler) => this.on(AppEvents.EVENTS.REFRESH, handler);

    kendoAfterInit = () => this.emit(AppEvents.EVENTS.KENDO_AFTERINIT);
    onKendoAfterInit = (handler) => this.on(AppEvents.EVENTS.KENDO_AFTERINIT, handler);

    notify = args => this.emit(AppEvents.EVENTS.NOTIFY, args);
    onNofify = handler => this.on(AppEvents.EVENTS.NOTIFY, handler);

    notifyError = args => this.emit(AppEvents.EVENTS.NOTIFY_ERROR, args);
    onNofifyError = handler => this.on(AppEvents.EVENTS.NOTIFY_ERROR, handler);


    static EVENTS = {
        PRE_INIT: 'page.preInit',
        POST_INIT: 'page.postInit',
        CREATE: 'page.create',
        SAVE: 'page.save',
        DELETE: 'page.delete',
        REFRESH: 'page.refresh',
        MODEL_LOADED: 'model.loaded',
        KENDO_AFTERINIT: 'kendo.afterInit',
        NOTIFY: 'notify',
        NOTIFY_ERROR: 'notify_error',
        FORM_SUBMIT: 'form.submit'
    }
}

export default new AppEvents();